import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

const mode = process.env.VUE_APP_MODE
export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#333',
        // secondary: '#ffb200',
        secondary: mode === 'ats' || mode === 'atsDev' || mode === 'adam' || mode === 'adamDev' ? '#150958' : '#DF731C',
        // blueDark: '#1584d1'
        orange: '#FDB71A',
        blueDark: '#2F80C2'
      }
    }
  }
})
